import { render, staticRenderFns } from "./ManageBadges.vue?vue&type=template&id=5edc639c"
import script from "./ManageBadges.vue?vue&type=script&lang=js"
export * from "./ManageBadges.vue?vue&type=script&lang=js"
import style0 from "./ManageBadges.vue?vue&type=style&index=0&id=5edc639c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports